export default "__VITE_ASSET__D4ed$chg__"